import React from "react";
import { MdDeleteOutline, MdEdit, MdStar, MdStarOutline } from "react-icons/md";

import styles from "./AddressItem.module.scss";
import { FullAddressInterface } from "../../../common/types/interfaces";

interface Props {
  address: FullAddressInterface;
  onEdit: (address: FullAddressInterface) => void;
  onDelete: (id: number) => void;
  onSetDefault: (id: number) => void;
}

const streetOnly = (value?: string) => {
  if (!value) return "";
  return value.replace(/\s*\d.*$/, "").replace(/,\s*$/, "").trim();
};

const extras = (a: FullAddressInterface) => {
  const list: string[] = [];
  if (a.apartment) list.push(`квартира ${a.apartment}`);
  if (a.entrance) list.push(`подъезд ${a.entrance}`);
  if (a.floor) list.push(`этаж ${a.floor}`);
  if (a.intercom) list.push(`домофон ${a.intercom}`);
  return list;
};

export const AddressItem: React.FC<Props> = ({
  address,
  onEdit,
  onDelete,
  onSetDefault,
}) => {
  const extra = extras(address);
  const street = streetOnly(address.address?.value);
  const title = address.name || street || "Адрес";

  return (
    <div className={styles.Row}>
      <div className={styles.Bg} aria-hidden="true">
        <span className={styles.BgMain}>{street || title}</span>
        {address.city?.value && (
          <span className={styles.BgSub}>{address.city.value}</span>
        )}
      </div>

      <div className={styles.RowInfo}>
        <div className={styles.TopLine}>
          <button
            type="button"
            className={`${styles.StarButton} ${
              address.isGeneral ? styles.StarActive : ""
            }`}
            onClick={() => onSetDefault(address.id)}
            aria-label={
              address.isGeneral
                ? "Основной адрес"
                : "Сделать адрес основным"
            }
            title={address.isGeneral ? "Основной адрес" : "Сделать основным"}
          >
            {address.isGeneral ? (
              <MdStar size={18} />
            ) : (
              <MdStarOutline size={18} />
            )}
          </button>

          <span className={styles.Name}>{title}</span>
        </div>

        <div className={styles.AddressLine}>
          {address.city?.value && (
            <span className={styles.City}>{address.city.value}</span>
          )}
          {address.address?.value && (
            <span className={styles.AddressValue}>{address.address.value}</span>
          )}
        </div>

        {extra.length > 0 && (
          <div className={styles.Extra}>{extra.join(" · ")}</div>
        )}

        {address.description && (
          <div className={styles.Comment}>{address.description}</div>
        )}

        <div className={styles.Actions}>
          <button
            type="button"
            className={styles.Action}
            onClick={() => onEdit(address)}
            aria-label="Изменить адрес"
          >
            <MdEdit size={16} />
            Изменить
          </button>

          <button
            type="button"
            className={`${styles.Action} ${styles.Danger}`}
            onClick={() => onDelete(address.id)}
            aria-label="Удалить адрес"
          >
            <MdDeleteOutline size={16} />
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
};